import { displayCurrencySymbol, displayCurrencyWithPrecision } from '@utils/currency';

import { formatStringAsNumber } from '@utils/numbers';
import { CurrencyFormatOptions } from './getCurrencyFormatOptions';

export const currencyFormatter = (options?: CurrencyFormatOptions) => (
  (value?: number | string): string => {
    if (!options) return '';
    const { precision, currency } = options;

    if (value === undefined || value === null || value === '') return '';
    const currencySymbol = displayCurrencySymbol(currency);
    const numberValue = typeof value === 'number'
      ? value
      : parseFloat(String(formatStringAsNumber(value)));

    return displayCurrencyWithPrecision(
      numberValue,
      currency,
      precision
    ).replace(currencySymbol, '').trim();
  }
);
